






























































































































import Vue from 'vue'
import SquareBlock from '@/components/map/SquareBlock.vue'
import Room from '@/components/map/Room.vue'
import Staircase from '@/components/map/Staircase.vue'
import SharedRoom from '@/components/map/SharedRoom.vue'
import DemoWestCommonArea from '@/components/map/static-maps/demo/subcomponents/DemoWestCommonArea.vue'
export default Vue.extend({
  components: { DemoWestCommonArea, Staircase, Room, SquareBlock, SharedRoom },
  props: {
    patients: {
      type: Array,
      required: true,
    },
    patientsByRoomNumber: {
      type: Object,
      required: true,
    },
    sharedRooms: {
      type: Object,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sharedRoomsData: this.sharedRooms,
    }
  },
})
